import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function TermsOfService() {
  const navigate = useNavigate();
  const updated = 'March 31, 2026';

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-4 py-12 sm:px-6">
        <button onClick={() => navigate(-1)} className="flex items-center gap-1 text-xs text-slate-400 hover:text-slate-600 mb-6">
          <ArrowLeft className="h-3 w-3" /> Back
        </button>

        <h1 className="text-3xl font-bold text-slate-900 mb-2" data-testid="terms-title">Terms of Service</h1>
        <p className="text-sm text-slate-500 mb-8">Last updated: {updated}</p>

        <div className="prose prose-slate prose-sm max-w-none space-y-6 text-slate-700 leading-relaxed">

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mt-8 mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing or using the Sharda Lead Management System ("Sharda LMS," "the Service"), 
              you agree to be bound by these Terms of Service. If you do not agree, do not use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mt-8 mb-3">2. Description of Service</h2>
            <p>
              Sharda LMS is a business lead management and social media publishing platform. The Service provides 
              lead tracking, content creation, AI-powered content generation, social media scheduling and publishing, 
              analytics, and team collaboration tools.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mt-8 mb-3">3. User Accounts</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
              <li>You must provide accurate and complete information when creating an account.</li>
              <li>You are responsible for all activities that occur under your account.</li>
              <li>You must notify us immediately of any unauthorized use of your account.</li>
              <li>Passwords must meet our security requirements (minimum 8 characters with uppercase, lowercase, digit, and special character).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mt-8 mb-3">4. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Use the Service for any unlawful purpose or in violation of any applicable laws.</li>
              <li>Upload or transmit content that is defamatory, obscene, or infringes on third-party rights.</li>
              <li>Attempt to gain unauthorized access to the Service or other users' accounts.</li>
              <li>Use automated systems (bots, scrapers) to access the Service without authorization.</li>
              <li>Interfere with or disrupt the Service or its infrastructure.</li>
              <li>Violate the terms of service of any connected third-party platform (Facebook, LinkedIn, etc.).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mt-8 mb-3">5. Content & Intellectual Property</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>You retain ownership of content you create or upload to the Service.</li>
              <li>You grant us a limited license to host, display, and process your content as needed to provide the Service.</li>
              <li>AI-generated content is provided as-is. You are responsible for reviewing and ensuring it meets your needs and applicable laws before publishing.</li>
              <li>The Service, its design, and proprietary features are owned by Sharda LMS.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mt-8 mb-3">6. Third-Party Integrations</h2>
            <p>
              The Service connects to third-party platforms (Meta/Facebook, Instagram, LinkedIn, WordPress, Canva). 
              Your use of these integrations is subject to the respective platform's terms of service. 
              We are not responsible for the availability, content, or practices of third-party services.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mt-8 mb-3">7. Limitation of Liability</h2>
            <p>
              The Service is provided "as is" without warranties of any kind. We shall not be liable for any indirect, 
              incidental, special, consequential, or punitive damages arising from your use of the Service, 
              including but not limited to loss of data, revenue, or business opportunities.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mt-8 mb-3">8. Termination</h2>
            <p>
              We may suspend or terminate your access to the Service at our discretion, with or without notice, 
              for conduct that we determine violates these Terms or is harmful to other users, us, or third parties. 
              You may terminate your account at any time by contacting us.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mt-8 mb-3">9. Changes to Terms</h2>
            <p>
              We may update these Terms from time to time. We will notify you of significant changes by posting the new Terms 
              on this page. Continued use of the Service after changes constitutes acceptance of the new Terms.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mt-8 mb-3">10. Contact</h2>
            <div className="bg-slate-50 border border-slate-200 rounded-lg p-4">
              <p><strong>Sharda LMS</strong></p>
              <p>Email: <a href="mailto:support@shardalms.com" className="text-blue-600 underline">support@shardalms.com</a></p>
              <p>Website: <a href="https://shardalms.com" className="text-blue-600 underline">https://shardalms.com</a></p>
            </div>
          </section>

        </div>

        <div className="mt-12 pt-6 border-t border-slate-200 text-center text-xs text-slate-400">
          Sharda LMS &copy; {new Date().getFullYear()}. All rights reserved.
        </div>
      </div>
    </div>
  );
}
